import { createFileRoute } from "@tanstack/react-router";
import { NightRecapEditor } from "@/components/night-recap/NightRecapEditor";

export const Route = createFileRoute("/night-recap/$memoryId")({
  head: () => ({
    meta: [
      { title: "Night Recap · Pulse" },
      {
        name: "description",
        content: "Share an editorial Night Recap card from your Pulse memories.",
      },
    ],
  }),
  component: NightRecapRoute,
});

function NightRecapRoute() {
  const { memoryId } = Route.useParams();
  return <NightRecapEditor memoryId={memoryId} />;
}
